import { CONTENT_LOBBY_PAGE, INDEX_PAGE, JOBS_MY_MATCHES_PAGE } from '~/constants';

/**
 * @description Routes where we dont want to show mobile banner for downloading the app.
 */
export const invalidRoutes = [CONTENT_LOBBY_PAGE, INDEX_PAGE, JOBS_MY_MATCHES_PAGE];
